import { Component, OnInit, Input, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { Filter } from '../filter.model';
import {formatDate} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import { subMonths } from 'date-fns';

@Component({
  selector: 'app-filter-date',
  templateUrl: './filter-date.component.html',
  styleUrls: ['./filter-date.component.scss']
})
export class FilterDateComponent implements OnInit {
  @Input() filter: Filter;
  @Input() filterForm: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<any>();
  public selection;
  constructor(
    private fb: UntypedFormBuilder,
    @Inject(LOCALE_ID) private locale: string,
    private translateService: TranslateService

  ) { }


  ngOnInit(): void {
    let option = this.filter.options.ranges[0].id;
    let endDate = new Date();
    let initDate = subMonths(endDate, 1)
    if (this.filter.selected){
      option   = this.filter.selected.id;
      if (option === 'custom'){
        endDate  = this.filter.selected.value.fe;
        initDate = this.filter.selected.value.fi;
      }
    }

    this.filterForm = this.fb.group({
      option:   option,
      initDate: new UntypedFormControl(initDate, Validators.required),
      endDate:  new UntypedFormControl(endDate, Validators.required)
    })
  }

  setCustomDate(){
    this.filterForm.controls.option.setValue('custom');
  }

  async onSubmit(){
    if (this.filterForm.valid){
      const formValue = this.filterForm.value;
      let fi = formValue.initDate;
      let fe = formValue.endDate;
      let label = 'custom'
      const filterName = this.translateService.instant(this.filter.name);
      let display = `${filterName}: ${formatDate(formValue.initDate, 'yyyy-MM-dd', this.locale)} - ${formatDate(formValue.endDate, 'yyyy-MM-dd', this.locale)}`;
      if (formValue.option !== 'custom'){
        console.log("formValue", formValue)
        let range = this.filter.options.ranges.find(range => range.id === formValue.option);
        console.log("Range", range);
        fi = range.value.fi;
        fe = range.value.fe;
        label = range.label;
        display = `${filterName}: ${range.label}`
      }
      this.filter.selected = {
        id: formValue.option,
        label,
        value: {fi, fe},
        display
      }
      this.filterChange.emit(this.filter);
    }
  }

}
